<template>
  <div class="menuPlaylist">
    <div class="menuPlaylist__barmenu">
      <div role="button" class="menuPlaylist__barmenu__btnback" @click="backToPlaylist">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back.svg" />Playlists
      </div>
      <div class="menuPlaylist__barmenu__btnscontplay">
        <div role="button" class="menuPlaylist__barmenu__btnscontplay__back" @click="$emit('change', 'back')">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back_playlist.png" />Anterior Playlist
        </div>
        <div role="button" class="menuPlaylist__barmenu__btnscontplay__next" @click="$emit('change', 'next')">
          Siguiente Playlist <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_next_playlist.png" />
        </div>
      </div>
      <div class="menuPlaylist__barmenu__btnthreepoint">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_option.png" @click.stop="openmenuopt" />
        <div v-if="showmenu" id="playlistMenu" class="menuPlaylist__barmenu__btnthreepoint__menu-cont">
          <div class="menuPlaylist__barmenu__btnthreepoint__menu-cont__opt-cont" @click="openConfirmExport">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/export.png" />
            <span>Exportar</span>
          </div>
          <div class="menuPlaylist__barmenu__btnthreepoint__menu-cont__sep"></div>
          <div class="menuPlaylist__barmenu__btnthreepoint__menu-cont__opt-cont" @click="openConfirmDelete">
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/trash2.png" />
            <span>Eliminar lista</span>
          </div>
        </div>
      </div>
      <div class="menuPlaylist__barmenu__btnscontplaymovil">
        <div role="button" class="menuPlaylist__barmenu__btnscontplaymovil__back" @click="$emit('change', 'back')">
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_back_playlist.png" />Anterior Playlist
        </div>
        <div role="button" class="menuPlaylist__barmenu__btnscontplaymovil__next" @click="$emit('change', 'next')">
          Siguiente Playlist <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_next_playlist.png" />
        </div>
      </div>
    </div>
    <div class="menuPlaylist__sep"></div>
    <div class="menuPlaylist__infoplaylist">
      <div class="menuPlaylist__infoplaylist__titlemovil">
        {{ playlist.name }}
      </div>
      <div class="movil-display">
        <div class="menuPlaylist__infoplaylist__img">
          <img :src="playlist.icon || 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_image@2x.png'" />
        </div>
        <div class="menuPlaylist__infoplaylist__infocont">
          <div class="menuPlaylist__infoplaylist__infocont__contdata">
            <div class="menuPlaylist__infoplaylist__infocont__contdata__title">
              {{ playlist.name }}
            </div>
            <div class="menuPlaylist__infoplaylist__infocont__contdata__description">
              {{ playlist.description }}
            </div>
          </div>
          <div class="menuPlaylist__infoplaylist__infocont__contmenu">
            <div role="button" class="menuPlaylist__infoplaylist__infocont__contmenu__play" @click="onClickPlay">
              Play
            </div>
            <div class="menuPlaylist__infoplaylist__infocont__contmenu__export" @click="openConfirmExport">
              Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
            </div>
            <div class="menuPlaylist__infoplaylist__infocont__contmenu__infovideos">
              Videos contenidos:
              <span class="menuPlaylist__infoplaylist__infocont__contmenu__infovideos__bold">
                {{ playlist.plays.length }}
              </span>
            </div>
          </div>
        </div>
        <div class="menuPlaylist__infoplaylist__contenttabletmenupanel">
          <div class="menuPlaylist__infoplaylist__contenttabletmenupanel__sep"></div>
          <div class="menuPlaylist__infoplaylist__contenttabletmenupanel__content">
            <div class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__infovideos">
              Videos contenidos:
              <span class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__infovideos__bold">
                {{ playlist.plays.length }}
              </span>
            </div>
            <div class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__sep"></div>
            <div class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__contentbtns">
              <div
                role="button"
                class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__contentbtns__play"
                @click="onClickPlay"
              >
                Play
              </div>
              <div
                class="menuPlaylist__infoplaylist__contenttabletmenupanel__content__contentbtns__export"
                @click="openConfirmExport"
              >
                Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menuPlaylist__infoplaylist__contmenumovil">
        <div class="menuPlaylist__infoplaylist__contmenumovil__infovideos">
          Videos contenidos:
          <span class="menuPlaylist__infoplaylist__contmenumovil__infovideos__bold">
            {{ playlist.plays.length }}
          </span>
        </div>
        <div class="menuPlaylist__infoplaylist__contmenumovil__contbuttonsfunction">
          <div
            role="button"
            class="menuPlaylist__infoplaylist__contmenumovil__contbuttonsfunction__play"
            @click="onClickPlay"
          >
            Play
          </div>
          <div
            class="menuPlaylist__infoplaylist__contmenumovil__contbuttonsfunction__export"
            @click="openConfirmExport"
          >
            Exportar<img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_export.png" />
          </div>
        </div>
      </div>
    </div>
    <MyPlaylistList :playlist-id="playlist.playlist_id" :playlist="playlist" />
    <ConfirmDeleteInPlaylist
      :question="`Esta playlist contiene ${playlist.plays.length} videos. ¿Estás seguro que deseas eliminarla?`"
      title="Eliminar Playlist"
      :showModalConfirm="showConfirmPlaylist"
      @onConfirmPlaylist="confirmModalPlaylistConfirm"
      @onCancelPlaylist="closeModalPlaylistConfirm"
    />
  </div>
</template>

<script>
import EventBus from '@/utils/event-bus';
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'MenuPlaylist',
  components: {
    MyPlaylistList: () => import('@/components/Sections/MediaPlayer-v2/modal-mode/MyPlaylistList'),
    ConfirmDeleteInPlaylist: () => import('@/components/Modals/ConfirmDeleteInPlaylist'),
  },
  props: {
    playlist: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { showConfirmPlaylist: false, showmenu: false, showConfirmExport: false };
  },
  computed: {
    ...mapState('mediaGeneral', ['userPlaylists']),
    ...mapState('mediaModal', ['modalSectionSelected']),
    ...mapState('loginGeneral', ['user']),
  },
  watch: {
    modalSectionSelected(newValue) {
      if (newValue !== 4) {
        this.backToPlaylist();
      }
    },
  },
  methods: {
    ...mapMutations(['setIsSectionLoading']),
    openConfirmExport() {
      this.$emit('export', { num: this.playlist.plays.length, id: this.playlist.playlist_id });
    },
    openmenuopt() {
      this.showmenu = true;
    },
    async confirmModalPlaylistConfirm() {
      try {
        this.setIsSectionLoading(true);
        const response = await axios.delete(
          `https://r6d08waisc.execute-api.us-east-2.amazonaws.com/prod/users/${this.user.id}/playlists/${this.playlist.playlist_id}`,
        );
        if (response.status === 200) {
          const deletedPlaylistIndex = this.userPlaylists.findIndex(
            playlist => playlist.playlist_id === this.playlist.playlist_id,
          );
          if (deletedPlaylistIndex !== -1) {
            this.userPlaylists.splice(deletedPlaylistIndex, 1);
          }
          this.backToPlaylist();
          this.showSuccess();
        }
        this.showConfirmPlaylist = false;
      } catch (e) {
        this.showError('La lista no pudo ser eliminada.');
        throw new Error(e);
      } finally {
        this.setIsSectionLoading(false);
      }
    },
    closeModalPlaylistConfirm() {
      this.showConfirmPlaylist = false;
    },
    showSuccess() {
      this.$buefy.notification.open({
        message: 'La playlist se elimino correctamente.',
        type: 'is-success',
      });
    },
    showError(msg) {
      this.$buefy.notification.open({
        duration: 6000,
        message: msg,
        type: 'is-danger',
      });
    },
    hideMenu(e) {
      if (!document.getElementById('playlistMenu').contains(e.target)) {
        if (this.showmenu) {
          this.showmenu = false;
        }
      }
    },
    openConfirmDelete() {
      this.showConfirmPlaylist = true;
      this.showmenu = false;
    },

    backToPlaylist() {
      this.$emit('back');
    },
    onClickPlay() {
      if (this.playlist.plays && this.playlist.plays.length) {
        EventBus.$emit('play-video', true);
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.hideMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenu);
  },
};
</script>

<style scoped lang="scss">
$blue: #132839;
$green: #cbee6b;
.movil-display {
  display: inline-flex;
  width: 100%;

  //@media screen and (max-width: 1176px) {
  //  display: grid;
  //  grid-template-columns: ;
  //
  //}
}

.menuPlaylist {
  font-size: 1rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  &__barmenu {
    width: 100%;
    height: 30px;
    display: inline-block;
    @media screen and (max-width: 1550px) {
      height: 70px;
      margin-bottom: 10px;
    }
    &__btnback {
      display: inline-block;
      float: left;
      display: flex;
      justify-content: center;
      width: fit-content;
      padding: 0.2em 0.8em 0.2em;
      border-radius: 20px;
      border: solid 1px #000;
      font-family: Roboto-Regular, sans-serif;
      font-size: 0.9375em;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.47;
      letter-spacing: -0.15px;
      cursor: pointer;
      img {
        margin-right: 0.3em;
      }
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &__btnscontplay {
      display: inline-block;
      width: 356px;
      @media screen and (max-width: 1550px) {
        display: none;
      }
      &__back {
        float: left;
        display: flex;
        justify-content: center;
        width: 164px;
        border-radius: 6px;
        background-color: #132839;
        padding: 0em 0.6em 0em;
        font-family: 'Avenir-Demi-Medium';
        line-height: 30px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        align-content: center;
        letter-spacing: -0.3px;
        text-align: left;
        color: #fff;
        white-space: nowrap;
      }
      &__next {
        float: right;
        display: flex;
        width: 174px;
        border-radius: 6px;
        background-color: #132839;
        justify-content: center;
        align-content: center;
        padding: 0em 0.6em 0em;
        font-family: 'Avenir-Demi-Medium';
        line-height: 30px;
        letter-spacing: -0.15px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        text-align: left;
        color: #fff;
        white-space: nowrap;
      }
    }
    &__btnscontplaymovil {
      width: 100%;
      display: none;
      margin-top: 10px;
      white-space: nowrap;

      @media screen and (max-width: 1550px) {
        display: inline-block;
      }
      &__back {
        float: left;
        display: flex;
        justify-content: center;
        width: 48%;
        border-radius: 6px;
        background-color: #132839;
        padding: 0em 0.6em 0em;
        font-family: 'Avenir-Demi-Medium';
        line-height: 30px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        align-content: center;
        letter-spacing: -0.3px;
        text-align: left;
        color: #fff;
        @media screen and (max-width: 400px) {
          font-size: 13px;
        }
        @media screen and (max-width: 315px) {
          font-size: 12px;
        }
      }
      &__next {
        float: right;
        display: flex;
        width: 48%;
        border-radius: 6px;
        background-color: #132839;
        justify-content: center;
        align-content: center;
        padding: 0em 0.6em 0em;
        font-family: 'Avenir-Demi-Medium';
        line-height: 30px;
        letter-spacing: -0.15px;
        cursor: pointer;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        text-align: left;
        color: #fff;
        @media screen and (max-width: 400px) {
          font-size: 13px;
        }
        @media screen and (max-width: 315px) {
          font-size: 12px;
        }
      }
    }
    &__btnthreepoint {
      display: inline-block;
      float: right;
      display: flex;
      position: relative;
      justify-content: center;
      width: fit-content;
      padding: 0.2em 0.8em 0.2em;
      font-family: 'Avenir-Demi-Medium';
      font-size: 0.9375em;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.47;
      letter-spacing: -0.15px;
      &__menu-cont {
        width: 252px;
        height: 112px;
        border-radius: 10px;
        box-shadow: 0 12px 43px 0 rgba(45, 58, 77, 0.46);
        background-color: #fff;
        position: absolute;
        right: 0px;
        top: -5px;
        &__opt-cont {
          width: 90%;
          margin-left: 0%;
          height: 32px;
          display: inline-flex;
          span {
            padding-left: 7px;
            font-size: 15px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 34px;

            letter-spacing: -0.3px;
            text-align: left;
            color: #132839;
            font-family: 'Avenir-Demi';
          }
          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
        &__opt-cont:first-child {
          margin-top: 22px;
        }
        &__sep {
          width: 90%;
          margin-left: 5%;
          height: 2px;
          border-bottom: 1px dotted #878e93;
          margin-top: 0px;
          margin-bottom: 5.5px;
        }
      }
    }
  }
  &__infoplaylist {
    width: 100%;
    height: fit-content;
    display: inline-flex;
    margin-bottom: 1em;
    @media screen and (max-width: 1420px) {
      display: inline-block;
    }
    @media screen and (max-width: 1176px) {
      display: inline-flex;
      border-radius: 9px;
      border: solid 1px #e4eef4;
      //height: 130px;
      padding: 5px;
    }
    @media screen and (max-width: 690px) {
      display: inline-block;
      //height: 224px;
    }
    &__contenttabletmenupanel {
      width: 250px;
      height: auto;
      display: none;
      @media screen and (max-width: 1176px) {
        display: inline-flex;
      }
      @media screen and (max-width: 690px) {
        display: none;
      }
      &__sep {
        width: 5px;
        height: 117px;
        border-right: 1px dashed #d1e0ea;
      }
      &__content {
        width: 100%;
        height: 117px;
        display: inline-block;
        &__infovideos {
          width: 100%;
          height: 60px;
          line-height: 60px;
          font-family: 'Avenir-Demi';
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.26px;
          text-align: center;
          color: #132839;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &__bold {
            font-size: 17px;
            font-family: 'Avenir-Bold';
          }
        }
        &__sep {
          width: 80%;
          margin-left: 10%;
          height: 1px;
          border-bottom: 1px dashed #d1e0ea;
        }
        &__contentbtns {
          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
          width: 100%;
          height: 58px;
          &__play {
            width: 92px;
            height: 30px;
            border-radius: 20px;
            background-color: #0f92ff;
            font-size: 14px;
            font-family: 'Avenir-Demi-Medium';
            font-weight: 500;
            line-height: 30px;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: -0.28px;
            color: #fff;
            &:hover {
              background: #006ec9;
              cursor: pointer;
              opacity: 0.96;
            }
          }
          &__export {
            width: 129px;
            height: 30px;
            border-radius: 20px;
            background-color: #132839;
            font-size: 14px;
            margin-left: 2%;
            font-weight: 500;
            display: inline-flex;
            justify-content: center;
            font-family: 'Avenir-Demi-Medium';
            font-stretch: normal;
            font-style: normal;
            line-height: 30px;
            letter-spacing: -0.28px;
            color: #fff;
            img {
              width: 16px;
              height: 16px;
              margin-top: 4px;
              margin-left: 8px;
            }
            &:hover {
              background: #163c5a;
              cursor: pointer;
              opacity: 0.96;
            }
          }
        }
      }
    }
    &__contmenumovil {
      width: 100%;
      height: auto;
      display: none;
      justify-content: left;
      align-items: center;
      @media screen and (max-width: 1420px) {
        display: inline-block;
      }
      @media screen and (max-width: 1176px) {
        display: none;
      }
      @media screen and (max-width: 690px) {
        display: inline-block;
      }
      &__contbuttonsfunction {
        width: 100%;
        height: 33px;
        line-height: 26px;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 600px) {
          justify-content: center;
        }
        &__play {
          width: 40%;
          height: 30px;
          border-radius: 30px;
          background-color: #0f92ff;
          font-size: 15px;
          font-family: 'Avenir-Demi-Medium';
          font-weight: 500;
          line-height: 26px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.28px;
          color: #fff;
          &:hover {
            background: #006ec9;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__export {
          width: 50%;
          height: 30px;
          display: inline-flex;
          border-radius: 30px;
          background-color: #132839;
          font-size: 15px;
          margin-left: 2%;
          font-weight: 500;
          display: inline-flex;
          justify-content: center;
          font-family: 'Avenir-Demi-Medium';
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: -0.28px;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-top: 4px;
            margin-left: 8px;
          }
          &:hover {
            background: #163c5a;
            cursor: pointer;
            opacity: 0.96;
          }
        }
      }
      &__sep {
        width: 100%;
        height: 2px;
        margin-bottom: 0px;
        display: inline-block;
        border-bottom: 1px dashed #d1e0ea;
      }
      &__play {
        width: 74px;
        height: 26px;
        border-radius: 20px;
        background-color: #0f92ff;
        font-size: 14px;
        font-family: 'Avenir-Demi-Medium';
        font-weight: 500;
        line-height: 26px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: -0.28px;
        color: #fff;
        &:hover {
          background: #006ec9;
          cursor: pointer;
          opacity: 0.96;
        }
      }
      &__export {
        width: 119px;
        height: 26px;
        border-radius: 20px;
        background-color: #132839;
        font-size: 14px;
        margin-left: 2%;
        font-weight: 500;
        display: inline-flex;
        justify-content: center;
        font-family: 'Avenir-Demi-Medium';
        font-stretch: normal;
        font-style: normal;
        line-height: 26px;
        letter-spacing: -0.28px;
        color: #fff;
        img {
          width: 16px;
          height: 16px;
          margin-top: 4px;
          margin-left: 8px;
        }
        &:hover {
          background: #163c5a;
          cursor: pointer;
          opacity: 0.96;
        }
      }
      &__infovideos {
        width: 100%;
        height: 30px;
        line-height: 26px;
        margin-bottom: 5px;
        font-family: 'Avenir-Demi';
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        margin-top: 10px;
        font-style: normal;
        letter-spacing: -0.26px;
        text-align: center;
        border-top: 1px dashed #d1e0ea;
        border-bottom: 1px dashed #d1e0ea;
        color: #132839;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &__bold {
          font-size: 17px;
          font-family: 'Avenir-Bold';
        }
      }
    }
    &__titlemovil {
      width: 100%;
      height: 24px;
      display: none;
      @media screen and (max-width: 1420px) {
        display: inline-block;
      }
      @media screen and (max-width: 1176px) {
        display: none;
      }
      @media screen and (max-width: 690px) {
        display: inline-block;
        width: calc(100vw - 70px);
      }
      font-size: 23px;
      font-family: 'Avenir-Demi';
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 24px;
      letter-spacing: -0.52px;
      text-align: left;
      color: #132839;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__img {
      width: 28%;
      max-width: 126px;
      height: 100%;
      @media screen and (max-width: 1420px) {
        width: 100%;
        max-width: 94px;
      }
      @media screen and (max-width: 1176px) {
        width: 100%;
        max-width: 117.7px;
      }
      @media screen and (max-width: 690px) {
        width: 100%;
        max-width: 94px;
      }
      img {
        width: 100%;
        max-width: 126px;
        @media screen and (max-width: 1420px) {
          width: 100%;
          max-width: 94px;
        }
        @media screen and (max-width: 1176px) {
          width: 100%;
          max-width: 117.7px;
        }
      }
    }
    &__infocont {
      width: 78%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      height: 100%;
      margin-left: 2%;
      @media screen and (max-width: 1176px) {
        //width: 54%;
      }
      @media screen and (max-width: 690px) {
        //width: 78%;
      }
      &__contdata {
        width: 100%;
        height: 70px;
        margin-top: 3px;
        display: inline-block;
        @media screen and (max-width: 1420px) {
          height: 98px;
        }
        @media screen and (max-width: 1176px) {
          margin-top: 0;
          height: 135px;
          width: calc(100vw - 450px);
        }
        @media screen and (max-width: 768px) {
          width: calc(100vw - 400px);
        }
        @media screen and (max-width: 690px) {
          height: 98px;
          margin-top: 3px;
        }
        &__title {
          width: 100%;
          height: 28px;
          padding-top: 2px;
          margin-top: 5px;
          @media screen and (max-width: 1420px) {
            display: none;
          }
          @media screen and (max-width: 1176px) {
            display: inline-block;
            width: calc(100vw - 450px);
          }
          @media screen and (max-width: 768px) {
            width: calc(100vw - 400px);
          }
          @media screen and (max-width: 690px) {
            display: none;
          }
          font-size: 26px;
          font-family: 'Avenir-Demi';
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.85;
          letter-spacing: -0.52px;
          text-align: left;
          color: #132839;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &__description {
          width: 100%;
          height: 34px;
          margin-top: 9px;
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.31;
          font-family: 'Avenir-Regular';
          letter-spacing: -0.26px;
          text-align: left;
          color: #132839;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          @media screen and (max-width: 1420px) {
            -webkit-line-clamp: 4;
            height: 82px;
          }
          @media screen and (max-width: 1176px) {
            display: inline-block;
            width: calc(100vw - 450px);
          }
          @media screen and (max-width: 768px) {
            width: calc(100vw - 400px);
          }
          @media screen and (max-width: 690px) {
            -webkit-line-clamp: 5;
            height: 82px;
            padding-right: 10px;
            width: calc(100vw - 160px);
          }
        }
      }
      &__contmenu {
        width: 100%;
        margin-top: 2px;
        height: 49px;
        display: inline-flex;
        justify-content: left;
        align-items: center;
        @media screen and (max-width: 1420px) {
          display: none;
        }
        &__play {
          width: 74px;
          height: 26px;
          border-radius: 20px;
          background-color: #0f92ff;
          font-size: 14px;
          font-family: 'Avenir-Demi-Medium';
          font-weight: 500;
          line-height: 26px;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.28px;
          color: #fff;
          &:hover {
            background: #006ec9;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__export {
          width: 119px;
          height: 26px;
          border-radius: 20px;
          background-color: #132839;
          font-size: 14px;
          margin-left: 2%;
          font-weight: 500;
          display: inline-flex;
          justify-content: center;
          font-family: 'Avenir-Demi-Medium';
          font-stretch: normal;
          font-style: normal;
          line-height: 26px;
          letter-spacing: -0.28px;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-top: 4px;
            margin-left: 8px;
          }
          &:hover {
            background: #163c5a;
            cursor: pointer;
            opacity: 0.96;
          }
        }
        &__infovideos {
          width: 50%;
          height: 26px;
          border-radius: 20px;
          line-height: 26px;
          font-family: 'Avenir-Demi';
          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: -0.26px;
          text-align: left;
          color: #132839;
          margin-left: 2%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &__bold {
            font-size: 17px;
            font-family: 'Avenir-Bold';
          }
        }
      }
    }
  }
  &__sep {
    width: 100%;
    height: 8px;
    margin-bottom: 8px;
    margin-top: 8px;
    display: inline-flex;
    border-bottom: 1px dashed #d1e0ea;
    @media screen and (max-width: 1550px) {
      display: none;
    }
  }
}
</style>
